import React from 'react'
import PropTypes from 'prop-types'
import { renderPanelWithContent } from '../../../resources/renderingUtilities'
import { dataAppStorage, patientsDatabase } from '../../../index'
import Loading from '../../common/Loading/Loading'
import PhotoEditor from '../../common/PhotoEditor/PhotoEditor'
import { Panel } from '../../common/Panel/Panel'

import './style.css'

export default class PatientIdentification extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      loading: ''
    }
    this.savePatientPersonalData = this.savePatientPersonalData.bind(this)
    this.uploadToDatabase = this.uploadToDatabase.bind(this)
  }

  componentWillMount () {
    this.props.hidePatientIndicator(true)
    if (this.props.auth.isAuthenticated()) {
      if (this.props.match.params.patientId) {
        if (!this.props.patientKey) {
          this.props.patientChangeHandle(this.props.match.params.patientId)
        }
      } else {
        this.props.history.replace('/patients')
      }
    }
  }

  renderPatientData () {
    if (this.props.configuration && this.props.configuration['patientIdentification']) {
      return renderPanelWithContent(this.props.configuration['patientIdentification'], this.savePatientPersonalData, this.props.patient, true)
    }
  }

  savePatientPersonalData (data, key) {
    Object.keys(data).forEach((dataKey) => {
      const patientRef = patientsDatabase.child(this.props.patientKey).child(dataKey)
      patientRef.set(data[dataKey])
    })
    const dataToLog = data
    dataToLog['data'] = undefined
    window.myLogger.info(JSON.stringify({message: 'Updated Patient Data', patient: this.props.patientKey, newData: dataToLog}))
  }

  getPatientPersonalData () {
    const configurationRef = patientsDatabase.child(this.props.patientKey)
    configurationRef.on('value', snapshot => {
      return snapshot.val()
    })
  }

  uploadToDatabase (photo) {
    return new Promise((resolve, reject) => {
      const storageRef = dataAppStorage.ref()
      storageRef.child(`userImages/${this.props.patient.patientNumber}`).put(photo).then((snapshot) => {
        if (snapshot.state === 'success') {
          resolve(snapshot.metadata.downloadURLs[0])
        } else {
          reject(new Error('Cannot Upload Photo'))
        }
      })
    })
  }

  handlePhotoSubmit (file) {
    if (file.size < 1000000) {
      this.setState({
        loading: 'loading'
      })
      this.uploadToDatabase(file).then(photoUrl => {
        const patientRef = patientsDatabase.child(this.props.patientKey).child('photo')
        patientRef.set(photoUrl)
        this.setState({
          loading: ''
        })
      })
    }
  }

  render () {
    if (this.props.patient) {
      window.myLogger.info(JSON.stringify({message: 'PatientIdentification Component Rendered', patient: this.props.patientKey}))
      return <div className={`container-fluid ${this.state.loading}`}>
        <div className='col-xs-12 col-md-3'>
          <Panel heading={'Photo'}>
            <PhotoEditor handlePhotoSubmit={this.handlePhotoSubmit.bind(this)} patientKey={this.props.patientKey} patient={this.props.patient} toggleModal={() => {}} />
          </Panel>
        </div>
        <div className='col-xs-12 col-md-9'>
          {this.renderPatientData()}
        </div>
      </div>
    } else {
      return <Loading />
    }
  }
}

PatientIdentification.propTypes = {
  patient: PropTypes.object,
  patientKey: PropTypes.string,
  auth: PropTypes.object.isRequired,
  patientChangeHandle: PropTypes.func.isRequired,
  hidePatientIndicator: PropTypes.func.isRequired,
  configuration: PropTypes.object.isRequired
}



// WEBPACK FOOTER //
// ./src/components/general/PatientIdentification/PatientIdentification.js